import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-academic',
  templateUrl: './curriculum.component.html',
  styleUrls: ['./curriculum.component.scss'],
  providers:[MasterService]
})
export class CurriculammasComponent implements OnInit { 

 // books: Book[];
  memberdetails:any[]=[];
  classdetails:any[]=[];
  closeResult: string;
  subgroup: any=[];
  subcat: any=[];
  subjects: any=[];
  subcomb: any=[];
  mascls:any=[];
  sucbid:any;
  classsub:any=[];
  filtcatgory:any[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  clid:any;
crid:any;
arrcourse:any=[];
  objsubcat:any={};
  objsubgroup:any={};
  objsubject:any={};
  objsubcomb:any={};
  objsuballot:any={};
  arrsubcomdet:any=[];
  classes:any=[];
  arrfiltcourse:any=[];
  objsbdetfil:any={};
  
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  private modalRef1: NgbModalRef;


  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  ngOnInit(): void {
    this.Getsel_sp_massubcat();
    this.Getsel_sp_massubgp();
    this.Getsel_sp_massubjects();
    this.Getsel_sp_exmsubcomb();
    this.Getclasslist();
    this.getcourselist();
    this.SelectClsSubDetails();
    
    
  }
  Getclasslist() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.mascls = resultArray;
            this.clid=resultArray[0].clid;
            this.objsbdetfil.clid=resultArray[0].clid;
            this.SelectClsSubDetails();
            let resSTR = JSON.stringify(resultArray);
            console.log('jsonstrt',resSTR);
            this.composefiltercategory(resSTR);
        },
        error => console.log("Error :: " + error)
        )
}

getcourselist() {
  this.mservice.mascourse()
      .subscribe(
      resultArray => {
          console.log('class-result', resultArray);
          this.arrcourse = resultArray;
          this.crid=resultArray[0].crid;
          this.objsbdetfil.crid=resultArray[0].crid;
          this.SelectClsSubDetails();
          let resSTR = JSON.stringify(resultArray);
          console.log('jsonstrt',resSTR);
          this.composecoursefilter(resSTR);
      },
      error => console.log("Error :: " + error)
      )
}
  Getsel_sp_massubgp()
  {
    debugger
    this.mservice.sel_sp_massubgp()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      //this.clsdate=resultArray;
      this.subgroup = resultArray;
      },
     error => console.log("Error :: " + error)
  )
  }

  SelectClsSubDetails() {
    debugger
    var clid = this.clid;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    var clssubdata = { clid: clid,clcd:clcd,aycd:aycd,crid:this.crid };
    console.log('model', clssubdata);
    this.mservice.masclasssubject(clssubdata)
        .subscribe(resultArray => {
            console.log('classsubs', resultArray);
            this.classsub = resultArray;
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    //this.closeAddExpenseModal.nativeElement.click();
}
  Getsel_sp_massubcat()
  {
    debugger
    this.mservice.sel_sp_massubcat()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      //this.clsdate=resultArray;
      this.subcat =  resultArray;
      },
     error => console.log("Error :: " + error)
  )
  }
  
  onChangefiltcat(selval)
{
debugger;
  //alert(selval);
this.clid=selval;
this.SelectClsSubDetails();
}

onChangecourse(selval)
{
debugger;
  //alert(selval);
this.crid=selval;
this.SelectClsSubDetails();
}
  composefiltercategory(jstring)
  {
    var newstr = jstring.replace(/clid/g, "value"); 
    var newstr = newstr.replace(/clnm/g, "label"); 
    console.log('jsonrep',newstr);
    let resJSON = JSON.parse(newstr);
    var arr=Array.of(resJSON);
   
    this.filtcatgory=arr[0];
    console.log('filtcatgory',this.filtcatgory);
  }

  composecoursefilter(jstring)
  {
    var newstr = jstring.replace(/crid/g, "value"); 
    var newstr = newstr.replace(/crnm/g, "label"); 
    console.log('jsonrep',newstr);
    let resJSON = JSON.parse(newstr);
    var arr=Array.of(resJSON);
   
    this.arrfiltcourse=arr[0];
    console.log('filtcatgory',this.arrfiltcourse);
  }
  Getsel_sp_massubjects()
  {
    debugger
    this.mservice.sel_sp_massubjects()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      //this.clsdate=resultArray;
      this.subjects =  resultArray;
      },
     error => console.log("Error :: " + error)
  )
  }

  Getsel_sp_exmsubcomb()
{
  debugger
  this.mservice.sel_sp_exmsubcomb()
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    //this.clsdate=resultArray;
    this.subcomb = resultArray;
    this.objsbdetfil.sucbid=resultArray[0].sucbid
    },
   error => console.log("Error :: " + error)
)
}

sel_cursucbd(sucbid,clid,crid)
{
  debugger
  this.mservice.sel_cursucbd(sucbid,clid,crid)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    //this.clsdate=resultArray;
    if(resultArray != undefined)
    {
    resultArray.forEach(x => x.active = x.active === 'Yes');
    this.arrsubcomdet = resultArray;
    }
    else{
      this.arrsubcomdet=[];
    }
    },
   error => console.log("Error :: " + error)
)
}

onchangecat(e,obj)
{

  console.log(e.checked);
  //console.log(obj);
  // this.categorymodel=obj;
  // this.categorymodel.status=e.checked;
  // this.categorymodel.oprtype='updstatus';
  // this.SavecatDetails();
  if(e.checked)
  {
    var active="Yes";
  }
  else {
    var active="No";
  }
  var pst={rid:obj,active:active};

  this.mservice.upd_cursucbd(pst)
  .subscribe(
  result => {
      console.log('SavegenmasDetails', result);
      //this.suppliers = resultArray;
      alert(result.message);
      
  },
  error =>{ alert('Error While saving...');}
  )
}



opensubdet(content,sucbid) {
  debugger
  
  this.sucbid=sucbid;
  this.sel_cursucbd(sucbid,this.clid,this.crid);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

opensubcomdet(content,clid,crid) {
  debugger
  
  this.clid=clid;
  this.crid=crid;
  this.SelectClsSubDetails();
 // this.sel_cursucbd(sucbid,this.clid);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef1=this.modalService.open(content,this.modalOptions);
  
  this.modalRef1.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}
 
opensubcate(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objsubcat={};
   
    
    
    this.objsubcat.suscid=0;
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objsubcat.oprtag='insert';
   
  }

  else if(cmd=='update')
  {
    this.objsubcat=objdata;
    this.objsubcat.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


SavegenmasDetails()
{
console.log('saveobj',this.objsubcat);
  this.mservice.save_sp_massubcat(this.objsubcat)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.Getsel_sp_massubcat();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}


opensubgroup(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objsubgroup={};
   
    
    
    this.objsubgroup.sugpid=0;
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objsubgroup.oprtag='insert';
   
  }

  else if(cmd=='update')
  {
    this.objsubgroup=objdata;
    this.objsubgroup.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


SavesubgroupDetails()
{
console.log('saveobj',this.objsubgroup);
  this.mservice.save_sp_massubgp(this.objsubgroup)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.Getsel_sp_massubgp();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}

opensubject(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objsubject={};
   
    
    
    this.objsubject.suid=0;
    this.objsubject.sugpid=0;
    this.objsubject.suscid=0;
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objsubject.oprtag='insert';
   
  }

  else if(cmd=='update')
  {
    this.objsubject=objdata;
    this.objsubject.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


Savesubjectdetails()
{
console.log('saveobj',this.objsubject);
  this.mservice.save_sp_massubjects(this.objsubject)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.Getsel_sp_massubjects();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}


opensubcomb(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objsubcomb={};
   
    
    
    this.objsubcomb.sucbid=0;
    
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objsubcomb.oprtag='insert';
   
  }

  else if(cmd=='update')
  {
    this.objsubcomb=objdata;
    this.objsubcomb.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


Savesubcomb()
{
console.log('saveobj',this.objsubcomb);
  this.mservice.save_sp_exmsubcomb(this.objsubcomb)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.Getsel_sp_exmsubcomb();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}


Savesubcombder(sucbid,suid)
{
  debugger;
//console.log('saveobj',this.objsubcomb);
var pst={sucbid:sucbid,suid:suid,clid:this.clid,crid:this.crid}
  this.mservice.save_cursucbd(pst)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef1;
            localmodref.close();
            this.sel_cursucbd(sucbid,this.clid,this.crid);

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}


opensuballot(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objsuballot={};
   
    
    
    this.objsuballot.suid=0;
    this.objsuballot.rid=0;
    this.objsuballot.clid=this.clid;
    this.objsuballot.crid=this.crid;
    
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objsuballot.oprtag='insert';
   
  }

  else if(cmd=='update')
  {
    this.objsuballot=objdata;
    this.objsuballot.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


save_sp_masclasssubject()
{
console.log('saveobj',this.objsuballot);
  this.mservice.save_sp_masclasssubject(this.objsuballot)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.SelectClsSubDetails();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}

deleteclasssubject(obj)
{
if(confirm("Are you sure you want to delete ?"))
{
  this.objsuballot=obj;
this.objsuballot.oprtag='delete';
this.save_sp_masclasssubject();


}

}

}
